import React from 'react';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import AddressForm from '../../../SaleJetBlock/Partials/AddressForm/AddressForm'
import CheckBox from '../../../../Shared/CheckBox/Checkbox';

const Address = (props) => {
    return (

        <>
            <div className='main'>
                <h3 className='title-black'>{'היי ' + props.firstName + ', '}
                    {props.isReqTechnician ? 'מה הכתובת החדשה שאליה יגיע הטכנאי?' : 'מה הכתובת החדשה שלך? '}
                </h3>
                <div className='AddressFormContainer'>
                    <div className='address-container'>
                        <AddressForm
                            //selectedAddress={props.selectedAddress}
                            isSubmit={props.isSubmit}
                            onSubmit={props.handlePageValidate} />
                    </div>
                    {/* <div className='address-private-home'>
                        <div className='address-private-home-text'>*אם זה בית פרטי הקלידו מספר דירה 0</div>
                    </div> */}
                    <div className='AddressFormCheckBox'>
                        <div className='bottom-checkbox'>
                            <CheckBox
                                id='agreementCheckbox'
                                onCheck={() => props.onMailingAddressChanged(true)}
                                onUncheck={() => props.onMailingAddressChanged(false)}
                                checked={props.isCheckedUpdateDeliveryAddress}
                                label={''}
                            />
                            <span className='checkBoxAlert'>לכתובת הזאת נשלח את כל הדואר על מוצרי {window.Config.brand_Name_HE} שלך. <br />אם נשלחת אליך חשבונית דיגיטלית היא תמשיך להגיע כרגיל</span>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};
export default Address;
